export const PAYMENT_UPFRONT_RATE_LOOKUP = {
  "0.50": 0.04,
  "1": 0.07,
};

export const LOCALE = "vi-VN";

export const PRICE_FORMATTING: Intl.NumberFormatOptions = {
  maximumFractionDigits: 0,
  style: "currency",
  currency: "VND",
  currencyDisplay: "symbol",
};



// WEBPACK FOOTER //
// ./src/routes/WizardSummary/constants.ts